/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";
import { useSelector } from "store";
import { LiveCommerceAddress } from "ui/Streaming/LiveCommerce/LiveCommerceAddress";
import { LiveCommerceAddressNoRegister } from "ui/Streaming/LiveCommerce/LiveCommerceAddressNoRegister";

import type { AddressInfo } from "modules/auth";

type Props = {
  addressInfo: AddressInfo | null;
};

export const StreamingLiveCommerceAddressV2: React.FC<Props> = (props) => {
  const isDarkModeEnabled = useSelector(
    (state) => state.streaming.streamingSettings.isDarkModeEnabled
  );

  const isAddressRegistered = useSelector(
    (state) => state.auth.isAddressRegistered
  );

  const { t } = useI18n();

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <p
        css={css`
          color: ${isDarkModeEnabled ? "#fff" : "#000"};
          font-size: 16px;
          font-weight: 700;
        `}
      >
        {t("streaming.commerceCart.address")}
      </p>

      {isAddressRegistered && props.addressInfo ? (
        <LiveCommerceAddress
          isDarkModeEnabled={isDarkModeEnabled}
          addressInfo={props.addressInfo}
        />
      ) : (
        <LiveCommerceAddressNoRegister isDarkModeEnabled={isDarkModeEnabled} />
      )}
    </div>
  );
};
